import React, {forwardRef} from 'react';
import ModalTemplate from "../../Wrappers/ModalTemplate";
import Select from "../../Atoms/Forms/Select";
import FormInput from "../../Atoms/Templates/FormInput";

const NewBankModal = forwardRef((props, ref) => {
  const handleCloseModal = () => {
    ref.current.closeModal()
  }

  return (
    <ModalTemplate
      ref={ref}
      className="medium s-center s-main-center"
    >
      <h3>Nueva cuenta de banco</h3>
      <form action="#"
        className="s-mb-0 ed-grid rows-gap form-grid">
        <Select
          label="Banco"
          isRequired
          placeholder
        >

        </Select>
        <FormInput
          placeholder="1234 5678 90"
          label="No. de cuenta"
          isRequired
        />

        <Select
          label="Método de pago"
          isRequired
          placeholder
        >

        </Select>

        <div className="buttons-container">
          <button className="button cancel" onClick={handleCloseModal}>Cancelar</button>
          <button className="button"
            disabled>Crea la cuenta
          </button>
        </div>
      </form>
    </ModalTemplate>
  );
})

export default NewBankModal;
